import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    commissionPlanTemplateType: null,
    commissionPlanTemplateTypes: null,
    isNew: false,
    lastState: null,
    lastScope: null
};

const commissionPlanTemplateTypeReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.COMMISSIONPLANTEMPLATETYPE_START: {
            return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
        }
        case actionTypes.COMMISSIONPLANTEMPLATETYPE_SUCCESS: {
            return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
        }
        case actionTypes.COMMISSIONPLANTEMPLATETYPE_FAIL: {
            return updateState(state, { lastState: constants.STATE_FAIL });
        }
        default: {
            return state;
        }
    }
};

export default commissionPlanTemplateTypeReducer;
